// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_text-align-justify--solid"><path id="Union" d="M21 21H3V19H21V21ZM21 17H3V15H21V17ZM21 13H3V11H21V13ZM21 9H3V7H21V9ZM21 5H3V3H21V5Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_text-align-justify--line"><path id="Union" d="M20.998 21H2.99805V19H20.998V21ZM20.998 17H2.99805V15H20.998V17ZM20.998 13H2.99805V11H20.998V13ZM20.998 9H2.99805V7H20.998V9ZM20.998 5H2.99805V3H20.998V5Z" style="fill: currentColor"/></g></svg>`;

export const TextAlignJustify: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
